<div class="form-detail">
  <kendo-panelbar *ngIf="!!infoFormation">
    <kendo-panelbar-item    (click)="changeLogo(i)" *ngFor="let infoBlock of infoFormation.details; index as i" [attr.id]='i'   [expanded]="tab[i]"  title="">
      <ng-template kendoPanelBarItemTitle>
        <div [attr.id]="'id-'+i" [ngClass]="closeItem[i] ? 'k-i-close' : 'k-i-plus'" class=" k-icon small-margin"></div>
        {{ infoBlock.title }}
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div [innerHTML]="infoBlock.content"></div>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
